const styles = {
  header: {
    gap: 5,
    display: 'flex',
    alignItems: 'center',
  },
  img: {
    maxHeight: 40,
    objectFit: 'contain',
  },
  group: {
    gap: 10,
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  bottom: {
    py: 2,
    bottom: 0,
    zIndex: 1000,
    display: 'flex',
    position: 'fixed',
    justifyContent: 'center',
    width: 'calc(100vw - 48px)',
    borderTop: '1px solid #e0e0e0',
  },
};

export default styles;
